import AbstractChart from './AbstractChart';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { chartColorCode, labelColor } from './colorCodes';
import moment from 'moment';
import {
  CHART_BACKGROUND_COLOUR,
  DEFAULT_CHART_HEIGHT,
  DEFAULT_CHART_WIDTH,
  FILTER_DATE_RANGE_FORMAT,
  DEFAULT_TITLE_STYLE,
  DEFAULT_NO_DATA_OPTIONS,
  SERIES_KEY,
  TITLE_KEY,
  TEXT_KEY
} from './constants/HighchartsConstants';
import { renderChart } from './CommonChartMethods';

class BarChart extends AbstractChart {
  constructor(props) {
    super(props);
    this.state = {
      chartData: [],
      source: [],
      mapDataFromProps: [],
      topicId: [],
      filterDateRange: {
        fromDate: moment().format(FILTER_DATE_RANGE_FORMAT),
        toDate: moment().format(FILTER_DATE_RANGE_FORMAT),
      },
      mapOptions: {
        chart: {
          type: 'bar',
          backgroundColor: CHART_BACKGROUND_COLOUR,
          marginBottom: 40,
          marginLeft: 50,
          marginTop: 45,
          width: DEFAULT_CHART_WIDTH,
          height: DEFAULT_CHART_HEIGHT,
        },
        noData: {...DEFAULT_NO_DATA_OPTIONS},
        legend: {
          x: -40,
          y: 80,
          floating: true,
          borderWidth: 1,
          shadow: true,
        },

        plotOptions: {
          series: {
            pointWidth: 10,
          },
          bar: {
            dataLabels: {
              enabled: true,
              color: '#999999',
              style: {
                fontSize: '8px',
                fontWeight: 'normal',
                textOutline: 0,
              },
              y: -2,
            },
          },
        },

        title: {...DEFAULT_TITLE_STYLE},
        tooltip: { enabled: false },
        credits: {
          enabled: false,
        },
        xAxis: {
          labels: {
            style: {
              color: '#999999',
              fontSize: '8px',
              lineHeight: '5px',
              textTransform: 'capitalize',
            },
            y: 2,
          },
          marginLeft: 50,
        },
        yAxis: {
          title: '',
          labels: {
            style: {
              color: '#999999',
              fontSize: '8px',
              lineHeight: '5px',
              textTransform: 'capitalize',
            },
          },
        },
      },
    };
  }

  parseBarChart = chart => {
    if (Object.keys(chart).length && typeof chart['values'] === 'object') {
      const updatedChart = chart['values'].map((item, index) => {
        return {
          y: item,
          color: chartColorCode[chart.categories[index].toLowerCase()],
          dataLabels: {
            color: labelColor[chart.categories[index].toLowerCase()],
          },
        };
      });
      return {
        categories: chart.categories.map(category => category.replace('_', ' ')),
        data: [
          {
            data: updatedChart,
          },
        ],
      };
    } else {
      return {
        categories: [],
        data: [{}],
      };
    }
  };

  reRenderChartOnChange = props => {
    let { mapOptions } = this.state;
    const { retrieveSelectedChartData } = this.props.actions;
    this.setState(
      {
        mapOptions,
        filterDateRange: props.dateRangeFilterValue,
        source: props.source,
        topicId: props.selectedTopicId,
      },
      () => {
        retrieveSelectedChartData({
          chartId: this.props.chartId.replace('chart', ''),
          dateFilterValue: this.state.filterDateRange,
          topicId: this.state.topicId,
          source: props.source,
        });
      },
    );
  };

  componentDidMount() {
    this.reRenderChartOnChange(this.props);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { chartId, selectedTopicId } = this.props;
    if (
      JSON.stringify(newProps.BarChart[chartId]) !== JSON.stringify(this.state.mapDataFromProps) &&
      newProps.selectedTopicId != null
    ) {
      this.setState({ chartData: [] });
      const { title } = this.props;
      const chartData = this.parseBarChart(newProps.BarChart[chartId]);
      let { mapOptions } = this.state;
      mapOptions[SERIES_KEY] = chartData['data'];
      mapOptions['xAxis']['categories'] = chartData['categories'];
      mapOptions[TITLE_KEY][TEXT_KEY] = title;
      console.log(title);
      this.setState({
        chartData,
        mapOptions,
        mapDataFromProps: newProps.BarChart[chartId],
        topicId: newProps.selectedTopicId,
      });
    }

    if (this._shouldReRenderChartBasedOnNewProps(newProps)) {
      this.reRenderChartOnChange(newProps);
    }
  }

  render() {
    const { mapOptions, mapDataFromProps } = this.state;
    return renderChart(mapOptions, mapDataFromProps);
  }
}

function mapStateToProps(state) {
  return {
    BarChart: state.charts,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BarChart);



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/BarChart.js